// app/javascript/lib/auto_save/local_storage.js

/**
 * @param {string} key
 * @returns {Record<string, string> | null}
 */
export function get(key) {
  const raw = localStorage.getItem(key);
  if (raw == null) return null;
  try {
    return JSON.parse(raw);
  } catch {
    return null;
  }
}

/**
 * @param {string} key
 * @param {Record<string, string>} data
 */
export function set(key, data) {
  localStorage.setItem(key, JSON.stringify(data));
}

/**
 * @param {string} key
 */
export function remove(key) {
  localStorage.removeItem(key);
}
